import React, { useEffect, useMemo } from "react";
import { Provider } from "mobx-react";
import { OFTableController } from "./OFTableController";
import { OFTableTypes } from "./OFTableTypes";
import { RenderTableMenu } from "./components/RenderTableMenu";
import { RenderLoader } from "./components/RenderLoader";
import { RenderFooter } from "./components/RenderFooter";
import { ContextMenu } from "./components/ContextMenu";
// import HTML5Backend from 'react-dnd-html5-backend'
import { RenderSuperHeaders } from "./components/RenderSuperHeaders";
// import { DndProvider } from 'react-dnd'
import OFVList from "./components/OFVList";
import { RenderColumnTotals } from "./components/RenderColumnTotals";
import { observer } from "mobx-react";
import { AppStore } from "~/stores/AppStore";

import "./TableStyles.scss";

const OFTable: React.FC<OFTableTypes> = observer(({ ...restProps }) => {
  const ofTableController = useMemo(() => new OFTableController(restProps), [restProps]);

  // Update controller properties when the props change
  useEffect(() => {
    ofTableController.loadingTable = restProps.loading;
    ofTableController.props = restProps;
  }, []);

  return (
    // <DndProvider backend={HTML5Backend}>
    <div className="OFTable" style={restProps.tableStyle ? restProps.tableStyle : {}}>
      {/* <ContextMenu
            contextMenuObj={restProps.contextMenuObj}
            customContextMenu={restProps.customContextMenu}
            ofTableController={ofTableController}
          /> */}
      {restProps.tableTitle && <div className="tableTitle">{restProps.tableTitle}</div>}
      <RenderTableMenu
        ofTableController={ofTableController}
        menuButtons={restProps.menuButtons}
        exportName={restProps.exportName}
        customExportName={restProps.customExportName}
        additionalExports={restProps.additionalExports}
      />
      <RenderLoader ofTableController={ofTableController} />
      <RenderSuperHeaders ofTableController={ofTableController} />

      {/* -------------------------------------------------------------------------- */}

      <OFVList ofTableController={ofTableController} />

      {/* -------------------------------------------------------------------------- */}

      <RenderColumnTotals ofTableController={ofTableController} />
      <RenderFooter ofTableController={ofTableController} />
    </div>
    // </DndProvider>
  );
});

export default OFTable;
